module.exports = __webpack_public_path__ + "img/eye-young-complete-3-water-metabolism.11ca5e49.jpg";